import { Component, Vue } from 'vue-property-decorator';
import WidgetList from './WidgetList/WidgetList.vue';
import WidgetContents from './WidgetContents/WidgetContents.vue';
import WidgetConfig from "@/components/Dashboard/Widgets/WidgetConfig/WidgetConfig.vue";
import { WidgetData } from "@/components/Dashboard/Widgets/types/Widget";

@Component({
    components: {
        WidgetList,
        WidgetContents,
        WidgetConfig
    }
})
export default class DashboardSetting extends Vue {
    private widgetLimit = 6
    private showWidgetConfig = false
    private widgetData: WidgetData = {
        id: '',
        title: '',
        component: '',
        config: null
    }
    private date = ''
    private isUpdateContent = false

    get refs(): any {
        return this.$refs;
    }

    private openModal(item: WidgetData, isUpdateContent: boolean) {
        this.isUpdateContent = isUpdateContent
        this.widgetData = item
        this.showWidgetConfig = true
    }

    // 設定モーダルの保存ボタンを押下した時に呼ばれる
    private updateWidget(item: WidgetData) {
        this.refs.wigetContents.updateContent(item, this.isUpdateContent)
        this.showWidgetConfig = false
    }
}